var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "termOfUseModal",
      staticClass: "modal fade",
      attrs: {
        id: "termOfUseModal",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "exampleModalCenterTitle",
      },
    },
    [
      _vm.language === "en"
        ? _c(
            "div",
            {
              staticClass: "modal-dialog go-modal-policy",
              staticStyle: { overflow: "hidden" },
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "modal-title" }, [
                    _vm._v("Terms of Service"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: {
                        id: "buttonClosePopupTermOfUse",
                        type: "button",
                        "data-dismiss": "modal",
                      },
                      on: { click: _vm.handleCloseElement },
                    },
                    [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "div",
                    { staticClass: "go-policy-content-wrap" },
                    [
                      _c(
                        "vue-custom-scrollbar",
                        {
                          staticClass:
                            "go-policy-content-inner overflow-y-scroll customScroll csScrollPosition ps",
                          attrs: { settings: _vm.scrollSettings },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                overflow: "hidden",
                                width: "auto",
                                height: "auto",
                              },
                            },
                            [
                              _c("div", { staticClass: "go-section" }, [
                                _c("div", { staticClass: "go-shortcut-box" }, [
                                  _c("strong", [_vm._v("Table of Contents")]),
                                  _vm._v(" "),
                                  _c(
                                    "ol",
                                    {
                                      staticClass: "go-shortcut-list",
                                      attrs: { start: "1" },
                                    },
                                    [
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "ts-s1-en"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a", [
                                            _vm._v(
                                              "Account Creation and Eligibility"
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "ts-s2-en"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a", [
                                            _vm._v(
                                              "Use of the Website and Services"
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "ts-s3-en"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a", [
                                            _vm._v(
                                              "Ownership; Proprietary Right"
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "ts-s4-en"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a", [
                                            _vm._v("Fees and Payment Terms"),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "ts-s5-en"
                                              )
                                            },
                                          },
                                        },
                                        [_c("a", [_vm._v("Confidentiality")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "ts-s6-en"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a", [
                                            _vm._v("Third-Party Contents"),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "ts-s7-en"
                                              )
                                            },
                                          },
                                        },
                                        [_c("a", [_vm._v("Disclaimer")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "ts-s8-en"
                                              )
                                            },
                                          },
                                        },
                                        [_c("a", [_vm._v("Indemnification")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "ts-s9-en"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a", [
                                            _vm._v("Limitation of Liability"),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "ts-s10-en"
                                              )
                                            },
                                          },
                                        },
                                        [_c("a", [_vm._v("Termination")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "ts-s11-en"
                                              )
                                            },
                                          },
                                        },
                                        [_c("a", [_vm._v("General")])]
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                  These Terms of Service (”Terms”) is entered into by and between you and Goover, LLC. as well as Goover’s parents,\n                  affiliates, and subsidiaries. (“Goover,” “we,” or “us”). The terms “you,” “your,” or “User” refer to you or a company,\n                  organization, or other entity on whose behalf you agree to these Terms. These Terms govern your access to and use of our\n                  services on our website goover.ai (“Website”) and all other services including, without limitation, services on a trial\n                  basis, beta services, or services that are free of charge (“Services”).\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                  These Terms limit our liability to you and include a class action waiver and waiver of jury trial. Disputes related to\n                  these terms must be settled through a dispute resolution process which may lead to binding arbitration. For more\n                  details, see section 9 ("
                                  ),
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.scrollToSection("ts-s9-en")
                                        },
                                      },
                                    },
                                    [_vm._v("Limitation of Liability")]
                                  ),
                                  _vm._v(") and section 11.10 ("),
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.scrollToSection(
                                            "ts-s11-10-en"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Dispute Resolution")]
                                  ),
                                  _vm._v(").\n                "),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                  Beside these terms, we also have additional terms, conditions, and policies that apply to your use of the Website and\n                  Services (“Supplemental Terms”) which are hereby incorporated by reference into these Terms. Goover can modify these\n                  Terms or service-related policies at any time. We will provide written notice of any material updates at least thirty\n                  (30) days before the effective date unless the changes result from changes in laws or regulations. Updated Terms and\n                  policies will be effective and binding upon the date indicated on the top of each document. Your continued use of the\n                  Website and Services following changes constitutes your agreement to such changes. You must stop using our Website or\n                  Services if you do not agree to the changes. You can find the updated Terms and Supplemental Terms at the links below:\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "go-table-wrap" }, [
                                  _c("table", { staticClass: "go-table" }, [
                                    _c("tbody", [
                                      _c("tr", [
                                        _c("th", [
                                          _vm._v(
                                            "Terms of Service Last Updated"
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [_vm._v("May 1, 2022")]),
                                      ]),
                                      _vm._v(" "),
                                      _c("tr", [
                                        _c("th", [_vm._v("Privacy Policy")]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            "Document that describes how Goover collects, uses, and shares data in our Website and Services"
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("tr", [
                                        _c("th", [
                                          _vm._v(
                                            "Personal Information Collection and Terms of Use"
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            "Document that allows Goover to collect your personal information"
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                  Please read these Terms carefully. Once accepted, these Terms become a binding legal contract between you and Goover. By\n                  checking the “I agree” box, you represent that\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "ol",
                                  { staticClass: "list-style-lowerAlpha" },
                                  [
                                    _c("li", [
                                      _vm._v(
                                        "you have read, understand, and agree to be bound by these Terms,"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "you are of legal age in your jurisdiction of residence to form a binding contract with Goover, and"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "\n                    you are entering into these Terms personally, or have the authority to enter into these Terms on behalf of any\n                    company, organization, or other legal entity on whose behalf you use the Website or Services.\n                  "
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                  If you do not agree to be bound by these terms, you should not accept these Terms, create an account, or use our Website\n                  or Services.\n                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "ts-s1-en" },
                                },
                                [
                                  _c("h2", [
                                    _vm._v(
                                      "1. Account Creation and Eligibility"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  To use our Website or Services, you must create an account. Before creating an account, you are responsible for ensuring\n                  that the use of our Website or Services complies with all laws and regulations applicable to you. When creating an\n                  account, you will be asked to provide your name and an email address or phone number. The information you provide us\n                  will be subject to our Privacy Policy. You must provide true, accurate, current, and complete information about\n                  yourself. If you breach these Terms, you are prohibited from creating new accounts and we may, at our sole discretion,\n                  deactivate or terminate your account and block access to our Website and Services.\n                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "ts-s2-en" },
                                },
                                [
                                  _c("h2", [
                                    _vm._v(
                                      "2. Use of the Website and Services"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  We own all rights, title and interest of our Website and Services. The Website and Services are protected by copyright\n                  laws and other intellectual property laws in the United State and throughout the world. Subject to these Terms, we grant\n                  you a limited, non-exclusive, non-transferable, non-sub-licensable license to use the Website and Services solely for\n                  your own non-commercial purposes. Any future, release, update, or other modification to the Website or Services shall be\n                  subject to these Terms. We reserve all right not granted in these Terms.\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("ol", [
                                    _c("li", [
                                      _c("h3", [
                                        _vm._v("2.1 Our Responsibilities"),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "Subject to these Terms, we will"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "ol",
                                        {
                                          staticClass: "list-style-lowerAlpha",
                                        },
                                        [
                                          _c("li", [
                                            _vm._v(
                                              "make the Services available to you in accordance with these Terms and our Supplemental Terms;"
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "provide the Services in accordance with laws applicable to our provision of the Services to you;"
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "\n                        make reasonable efforts to use industry standard measures to scan, detect, and delete code, files, scripts,\n                        agents, or programs intended to do harm, including viruses, worms, time bombs, and Trojan horses;\n                      "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "make reasonable efforts to provide you with adequate support for the Website and Services."
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [
                                        _vm._v("2.2 Service Restrictions"),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      You must use the Website and Services only in accordance with these Terms, Supplemental Terms, and applicable laws\n                      and regulations. The rights granted to you in these Terms are subject to following restrictions: you shall not\n                    "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "ol",
                                        {
                                          staticClass: "list-style-lowerAlpha",
                                        },
                                        [
                                          _c("li", [
                                            _vm._v(
                                              "\n                        sell, rent, lease, transfer, lease or otherwise commercially exploit the Website or Services or any portion of the\n                        Website or Services;\n                      "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "\n                        frame or enclose any trademark, logo of the Website or Services including, without limitation, images, text,\n                        scripts, page layout or form;\n                      "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "use any metatags or other “hidden text” using our name or trademarks;"
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "\n                        modify, translate, adapt, merge, disassemble, make derivative works of, or reverse engineer any part of the\n                        Website or Services;\n                      "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "\n                        use any automated or manual software, devices, or other processes to scrape or download data from the Website or\n                        Services;\n                      "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "use the Website or Services to build a similar or competitive website, application, or service;"
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "remove or destroy any copyright notices or other proprietary markings within the Website or Services."
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [
                                        _vm._v("2.3 Unauthorized Use"),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "You must not, under any circumstances:"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "ol",
                                        {
                                          staticClass: "list-style-lowerAlpha",
                                        },
                                        [
                                          _c("li", [
                                            _vm._v(
                                              "interfere with the proper functioning of the Website or Services;"
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "tampering with or circumventing any security or usage rules embedded in the Website or Services;"
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "\n                        harvesting or collecting contact information of other users from the Website or Services by electronic or other\n                        means;\n                      "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "\n                        disrupt, overburden, or aid in the disruption or overburdening of any computer, server, or other infrastructure\n                        used to offer or support our Website or Services;\n                      "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "attempt to gain unauthorized access to the Website or Services;"
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "\n                        access, tamper, or use non-public areas of the Website, Services, our computer systems, or technical delivery\n                        systems of our providers;\n                      "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "\n                        attempt to probe, scan, or test the vulnerability of any of our system or network, or breach any security or\n                        authentication measures;\n                      "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "\n                        disrupt or interfere with the security of, or otherwise cause harm to the Website, Services, systems, resources,\n                        accounts, passwords, servers or networks connected to or accessible through our Website or Services. Any\n                        unauthorized use of the Website or Services terminates the licenses granted to you in accordance with these Terms.\n                      "
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "ts-s3-en" },
                                },
                                [
                                  _c("h2", [
                                    _vm._v("3. Ownership; Proprietary Right"),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  We exclusively own and reserve all right, title and interested in the Website and Services. Any elements of the Website\n                  or Services, including, without limitation, visual interfaces, graphics, design, images, compilation, information, data,\n                  computer code, software provided by us are protected by intellectual property and other laws. You must not remove,\n                  alter, or obscure any copyright, trademark, service mark, or other proprietary rights notices incorporated in the\n                  Website or Services. All materials included in the Website or Services are our property or our third-party licensors. We\n                  reserve all rights not expressly granted under these Terms.\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("ol", [
                                    _c("li", [
                                      _c("h3", [_vm._v("3.1 Feedback")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      By submitting any ideas, suggestions, or proposals to us through our suggestion/feedback pages or other similar\n                      pages (“Feedback”), you grant us a fully paid, royalty-free, perpetual, irrevocable, non-exclusive, and fully\n                      sublicensable right to use, reproduce, and otherwise commercially or non-commercially exploit your Feedback in any\n                      manner.\n                    "
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "ts-s4-en" },
                                },
                                [
                                  _c("h2", [
                                    _vm._v("4. Fees and Payment Terms"),
                                  ]),
                                  _vm._v(" "),
                                  _c("ol", [
                                    _c("li", [
                                      _c("h3", [_vm._v("4.1 Fees")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      When you purchase any of our paid Services, you agree to pay all fees and/or charges to your account in accordance\n                      with the fees, charges, and billing terms in effect at the time the fee and/or charge is due and payable. You must\n                      provide us a valid credit card information and by providing us with your credit card number and other information\n                      necessary for processing the payment, you agree that we are authorized to immediately invoice your account for all\n                      fees and/or charges due and payable to us and that no additional notice or consent is required. Your agreement with\n                      the payment providers governs your use of the designated credit card, and you must refer to that agreement and not\n                      these Terms to determine your rights and liabilities. Recurring license charges are billed in advance in the\n                      frequency set forth in the order form, and usage-based and one-time charges are billed monthly in areears.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("4.2 Taxes")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      All fees are exclusive of any applicable taxes, levies, duties, or other similar exactions imposed by a legal,\n                      governmental, or regulatory authority in any applicable jurisdiction, including, without limitation, sales, use,\n                      value-added, consumption, communications, or withholding taxes (“Taxes”). You will pay all Taxes associated with\n                      these Terms, excluding any taxes based on our net income, property, or employees. If you are required by law to\n                      withhold any Taxes from payments owed to us, you will reduce or eliminate such withheld Taxes upon receipt of the\n                      appropriate tax certificates or document provided by us. You will provide us with proof of payment of any withheld\n                      Taxes to the appropriate authority. Taxes will be shown on a separate line item on your invoice.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("4.3 Price Changes")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      If we change the fees for the Services, including by adding additional fees or charges, we will provide you advance\n                      notice of those changes. If you do not accept the changes, we reserve the right to discontinue providing the\n                      Services to you.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [
                                        _vm._v(
                                          "4.4 Late Payments; Non-payments; Suspension"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      We reserve the right to deactivate, terminate, prevent access to, disable services for your account and prevent\n                      access to the Website and Services at any time at our sole discretion, including for nonpayment, late payment, or\n                      failure to charge your payment methods upon invoicing.\n                    "
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "ts-s5-en" },
                                },
                                [
                                  _c("h2", [_vm._v("5. Confidentiality")]),
                                  _vm._v(" "),
                                  _c("ol", [
                                    _c("li", [
                                      _c("h3", [
                                        _vm._v(
                                          "5.1 Definition of Confidential Information"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      Any nonpublic information from us that is designated confidential or, given the nature of the information or\n                      circumstances surrounding its disclosure, reasonably should be understood to be confidential (“Confidential\n                      Information”) must be handled according to these Terms.\n                    "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "Confidential Information includes but is not limited to:"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "ol",
                                        {
                                          staticClass: "list-style-lowerAlpha",
                                        },
                                        [
                                          _c("li", [
                                            _vm._v(
                                              "\n                        nonpublic information about our technology, customers, business plans, marketing and sales activities, finances,\n                        operations and other business information; and\n                      "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "\n                        the existence and content of our discussions or negotiations with you regarding your account or use of the Website\n                        or Services.\n                      "
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "Confidential Information does not include any information that:"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "ol",
                                        {
                                          staticClass: "list-style-lowerAlpha",
                                        },
                                        [
                                          _c("li", [
                                            _vm._v(
                                              "is or becomes publicly available without breach of these Terms;"
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "can be shown by documentation to have been known to you at the time of your receipt from us;"
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "\n                        is received from a third party who did not acquire or disclose the information by a wrongful or tortious act or by\n                        violating the rights of us or third parties; or\n                      "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "\n                        can be shown by documentation to have been independently developed by you without reference to the Confidential\n                        Information.\n                      "
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("5.2 Confidentiality")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      You shall not disclose or use any Confidential Information for any purpose outside the scope of these Terms unless\n                      you have our express consent. We may disclose Confidential Information to our personnel, auditors, accountants,\n                      attorneys or advisors who are subject to confidentiality obligations comparable in scope to those herein, which are\n                      in no event less than a reasonable standard of care.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("5.3 Protection")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      You shall use at least the same level of care to prevent unauthorized use of the Confidential Information as it uses\n                      for its own confidential and proprietary information of like kind, but in no event less than a reasonable standard\n                      of care. The confidentiality obligations contained herein supersede and replace any prior non-disclosure regarding\n                      the subject matter covered by these Terms.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [
                                        _vm._v("5.4 Compelled Disclosure"),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      We may disclose Confidential Information if so required pursuant to a regulation, law, subpoena, or court order\n                      (“Compelled Disclosures”), provided that we give you a notice of a Compelled Disclosure to the extent legally\n                      permitted. You shall provide reasonable cooperation to us in connection with a Compelled Disclosure.\n                    "
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "ts-s6-en" },
                                },
                                [
                                  _c("h2", [_vm._v("6. Third-Party Contents")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  The Website or Services may contain links to third-party websites, advertisers, services, special offers, or other\n                  events or activities that are not owned or controlled by us (“Third-Party Contents”). We do not endorse or assume any\n                  responsibility for any Third-Party Contents. If you access any Third-Party Contents through or in connection with your\n                  access or use of our Website or Services, you do so at your own risk and you agree that we will have no liability\n                  arising from your use of or access to any Third-Party Contents.\n                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "ts-s7-en" },
                                },
                                [
                                  _c("h2", [_vm._v("7. Disclaimer")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  YOU EXPRESSLY UNDERSTAND AND AGREE THAT TO THE EXTENT PERMITTED BY APPLICABLE LAW, YOUR USE OF THE WEBSITE AND SERVICES\n                  IS AT YOUR SOLE RISK, AND THE WEBSITE AND SERVICES ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS, WITH ALL FAULTS.\n                  WE EXPRESSLY DISCLAIM ALL WARRANTIES, REPRESENTATIONS, AND CONDITIONS OF ANY KIND, WHETHER EXPRESS OR IMPLIED,\n                  INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OR CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE\n                  AND NON-INFRINGEMENT.\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "WE MAKE NO WARRANTY, REPRESENTATION OR CONDITION THAT:"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "ol",
                                    { staticClass: "list-style-lowerAlpha" },
                                    [
                                      _c("li", [
                                        _vm._v(
                                          "THE WEBSITE OR SERVICES WILL MEET YOUR REQUIREMENTS;"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "YOUR USE OF THE WEBSITE OR SERVICES WILL BE UNINTERRUPTED, TIMELY, SECURE OR ERROR-FREE;"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "THE RESULTS THAT MAY BE OBTAINED FROM USE OF THE WEBSITE OR SERVICES WILL BE ACCURATE OR RELIABLE; OR"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "\n                    ANY ERRORS IN THE WEBSITE OR SERVICES WILL BE CORRECTED. THE SERVICES MAY BE SUBJECT TO DELAYS, CANCELLATIONS AND\n                    OTHER DISRUPTIONS.\n                  "
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED FROM US OR THROUGH THE WEBSITE OR SERVICE WILL CREATE ANY\n                  WARRANTY NOT EXPRESSLY MADE HEREIN.\n                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "ts-s8-en" },
                                },
                                [
                                  _c("h2", [_vm._v("8. Indemnification")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  You agree to indemnify, defend and hold harmless us, our corporate parents, subsidiaries, and affiliates, and the\n                  officers, directors, employees, agents, representatives, partners and licensors of each from any damages, losses, costs,\n                  liabilities and expenses (including reasonable attorneys’ fees) relating to or arising out of any claims concerning:\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "ol",
                                    { staticClass: "list-style-lowerAlpha" },
                                    [
                                      _c("li", [
                                        _vm._v(
                                          "your use, or inability to use the Website or Services;"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "your misuse of the Website or Services or violation of any of these Terms;"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "your violation of any rights of another party; or"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "your violation of any applicable laws, rules or regulations."
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  We reserve the right, at our own cost, to assume the exclusive defense and control of any matter otherwise subject to\n                  indemnification by you, in which event you will fully cooperate with us in asserting any available defenses. You agree\n                  that the provisions in this section will survive any termination of your account, these Terms or your access to the\n                  Website or Services.\n                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "ts-s9-en" },
                                },
                                [
                                  _c("h2", [
                                    _vm._v("9. Limitation of Liability"),
                                  ]),
                                  _vm._v(" "),
                                  _c("ol", [
                                    _c("li", [
                                      _c("h3", [
                                        _vm._v(
                                          "9.1 Disclaimer of Certain Damages"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, WE SHALL NOT BE LIABLE FOR ANY LOSS OF PROFITS OR REVENUE, LOSS\n                      OF GOODWILL, ACCURACY OF RESULTS OR FOR INDIRECT, INCIDENTAL, PUNITIVE, EXEMPLARY, SPECIAL OR CONSEQUENTIAL DAMAGES,\n                      OR DAMAGES OR COSTS DUE TO: THE WEBSITE OR SERVICES, INCLUDING YOUR USE OR INABILITY TO USE THEREOF; ANY CONTENT\n                      PROVIDED BY US; ANY ACTION TAKEN IN CONNECTION WITH ANY THIRD-PARTY INTELLECTUAL PROPERTY CLAIMS; LOSS OF DATA;\n                      PRODUCTION; OR, BUSINESS INTERRUPTION OR PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES, REGARDLESS OF WHETHER WE HAVE\n                      BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [
                                        _vm._v("9.2 Limitation of Liability"),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      UNDER NO CIRCUMSTANCES WILL WE BE LIABLE TO YOU FOR MORE THAN THE AMOUNT RECEIVED BY US AS A RESULT OF YOUR USE OF\n                      OUR WEBSITE AND SERVICES IN THE SUBSCRIPTION PERIOD DURING WHICH YOU FIRST ASSERT A CLAIM. IF YOU HAVE NOT PAID THE\n                      COMPANY ANY AMOUNTS IN THE SUBSCRIPTION PERIOD DURING WHICH YOU FIRST ASSERT ANY SUCH CLAIM, OUR SOLE AND EXCLUSIVE\n                      LIABILITY SHALL BE LIMITED TO FIFTY DOLLARS ($50).\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("9.3 Exceptions")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      SOME JURISDICTIONS DO NOT ALLOW FOR THE EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU, SOME\n                      OR ALL OF THE DISCLAIMERS, EXCLUSIONS, AND LIMITATIONS MAY NOT APPLY TO YOU AND YOU MIGHT HAVE ADDITIONAL RIGHTS.\n                    "
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "ts-s10-en" },
                                },
                                [
                                  _c("h2", [_vm._v("10. Termination")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  At our sole discretion, we may modify or discontinue the Website or Services, or may modify, suspend or terminate your\n                  access to the Website or Services, for any reason, with or without notice to you and without liability to you or any\n                  third party. In addition to suspending or terminating your access to the Website or Services, we reserve the right to\n                  take appropriate legal action, including without limitation, pursuing civil, criminal or injunctive redress. Even after\n                  your right to use the Website or Services is terminated, these Terms will remain enforceable against you and unpaid\n                  amounts you owe us will remain due. All sections which by their nature should survive the termination of these Terms\n                  shall continue in full force and effect notwithstanding any termination of these Terms.\n                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "ts-s11-en" },
                                },
                                [
                                  _c("h2", [_vm._v("11. General")]),
                                  _vm._v(" "),
                                  _c("ol", [
                                    _c("li", [
                                      _c("h3", [_vm._v("11.1 Assignment")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      These terms and your rights and obligations hereunder may not be assigned, subcontracted, delegated or otherwise\n                      transferred by you without our prior written consent, and any attempted assignment, subcontract, delegation, or\n                      transfer in violation of the foregoing will be null and void.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [
                                        _vm._v("11.2 Electric Communications"),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      We will communicate with you through electronic means, whether we post notices on our Website or Services,\n                      communicate with you via e-mail, or you visit the Website or Services. For contractual purposes, you\n                    "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "ol",
                                        {
                                          staticClass: "list-style-lowerAlpha",
                                        },
                                        [
                                          _c("li", [
                                            _vm._v(
                                              "onsent to receive communications from us in an electronic form; and"
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "\n                        agree that all terms and conditions, agreements, notices, disclosures, and other communications and documents that\n                        we provide you electronically will have the same legal effect that such communications or documents would have if\n                        they were set forth in paper-based “writing.”\n                      "
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("11.3 Notices")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      You agree that we may provide you notices by email, regular mail, or postings on the Website or Services. You may\n                      provide notice to us by contacting us at "
                                        ),
                                        _c("a", [_vm._v("contact@goover.ai")]),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [
                                        _vm._v("11.4 Third-Party Data"),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      At our sole discretion, we may modify or discontinue the Website or Services, or may modify, suspend or terminate\n                      your access to the Website or Services, for any reason, with or without notice to you and without liability to you\n                      or any third party. In addition to suspending or terminating your access to the Website or Services, we reserve the\n                      right to take appropriate legal action, including without limitation, pursuing civil, criminal or injunctive\n                      redress. Even after your right to use the Website or Services is terminated, these Terms will remain enforceable\n                      against you and unpaid amounts you owe us will remain due. All sections which by their nature should survive the\n                      termination of these Terms shall continue in full force and effect notwithstanding any termination of these Terms.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [
                                        _vm._v("11.5 Relationship of Parties"),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      The parties are independent contractors. These terms do not create a partnership, franchise, joint venture, agency,\n                      fiduciary or employment relationship between the parties.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("11.6 Severability")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      If any portion of these Terms is held invalid or unenforceable, that portion shall be construed in a manner to\n                      reflect, as nearly as possible, the original intention of the parties, and the remaining portions shall remain in\n                      full force and effect.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("11.7 Force Majeure")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      We shall not be liable for any delay or failure to perform resulting from causes outside our reasonable control,\n                      including, but not limited to, acts of God, war, epidemics, pandemics, terrorism, riots, embargos, acts of civil or\n                      military authorities, fire, floods, accidents, strikes or shortages of transportation facilities, fuel, energy,\n                      labor or materials.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [
                                        _vm._v("11.8 Governing Law and Venue"),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      These terms and any disputes arising out of these terms shall be governed by and construed in accordance with the\n                      laws of the State of California, without giving effect to its conflicts of laws rules, the United Nations Convention\n                      on the International Sale of Goods, or the Uniform Computer Information Transactions Act.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [
                                        _vm._v(
                                          "11.9 Venue; Waiver of Jury Trial"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      The state and Federal courts located in Santa Clara County, California shall have exclusive jurisdiction to\n                      adjudicate any dispute arising out of or relating to these Terms. Each party hereby consents to the exclusive\n                      jurisdiction of such courts and waives any objection it might otherwise have to venue, personal jurisdiction,\n                      inconvenience of forum, and any similar or related doctrine. Each party also hereby waives any right to jury trial\n                      in connection with any action or litigation in any way arising out these Terms.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      { attrs: { id: "ts-s11-10-en" } },
                                      [
                                        _c("h3", [
                                          _vm._v("11.10 Dispute Resolution"),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n                      In the interest of resolving disputes between Goover and you in the most expedient and cost-effective manner, both\n                      parties agree that every dispute arising in connection with these Terms will be resolved by binding arbitration.\n                      Arbitration is less formal than a lawsuit in court. Arbitration uses a neutral arbitrator instead of a judge or\n                      jury, may allow for more limited discovery than in court, and can be subject to very limited review by courts.\n                      Arbitrators can award the same damages and relief that a court can award. The agreement to arbitrate disputes\n                      includes all claims arising out of or relating to any aspect of these Terms, whether based in contract, tort,\n                      statute, fraud, misrepresentation, or any other legal theory, and regardless of whether a claim arises during or\n                      after the termination of these Terms. YOU UNDERSTAND AND AGREE THAT, BY ENTERING INTO THESE TERMS, BOTH PARTIES ARE\n                      WAIVING THE RIGHT TO A TRIAL BY JURY OR TO PARTICIPATE IN A CLASS ACTION.\n                    "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("11.11 Waiver")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      Any waiver or failure to enforce any provision of these Terms on one occasion will not be deemed a waiver of any\n                      other provision or of such provision on any other occasion.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [
                                        _vm._v(
                                          "11.12 Notice to California Residents"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      Under California Civil Code Section 1789.3, California residents are entitled to the following specific consumer\n                      rights information:\n                    "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "The provider of the Website is:"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        { staticClass: "list-style-disc" },
                                        [
                                          _c("li", [_vm._v("Goover LLC.")]),
                                          _vm._v(" "),
                                          _c("li", [_vm._v("440 N Wolfe Rd.")]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v("Sunnyvale, CA 94085"),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v("Email : "),
                                            _c("a", [
                                              _vm._v("contact@goover.ai"),
                                            ]),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      To file a complaint or to receive further information regarding use of the Website or Services, send a letter to the\n                      above address or contact us via e-mail or telephone.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [
                                        _vm._v("11.13 International Access"),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      The Website and Services may be accessed from countries other than the United States. We make no representations or\n                      warranties that the Website or Services are appropriate for use or access in other locations. If you access and use\n                      the Site or the Service outside the United States, you are responsible for complying with both United States and\n                      applicable local laws and regulations.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      [
                                        _c("h3", [
                                          _vm._v("11.14 Export Control"),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n                      The Website, Services, and other technology we make available, and derivatives thereof may be subject to export laws\n                      and regulations of the United States and other jurisdictions. In particular, the Website and Services shall not be\n                      exported or re-exported\n                    "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "ol",
                                          {
                                            staticClass:
                                              "list-style-lowerAlpha",
                                          },
                                          [
                                            _c("li", [
                                              _vm._v(
                                                "into any United States embargoed countries, or"
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("li", [
                                              _vm._v(
                                                "\n                        to anyone on the U.S. Treasury Department’s list of Specially Designated Nationals or the U.S. Department of\n                        Commerce’s Denied Person’s List or Entity List.\n                      "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("P", [
                                          _vm._v(
                                            "By using the Website or Services, you represent and warrant that"
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "ol",
                                          {
                                            staticClass:
                                              "list-style-lowerAlpha",
                                          },
                                          [
                                            _c("li", [
                                              _vm._v(
                                                "\n                        you are not located in a country that is subject to a U.S. Government embargo, or that has been designated by the\n                        U.S. Government as a “terrorist supporting” country and\n                      "
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("li", [
                                              _vm._v(
                                                "you are not listed on any U.S. Government list of prohibited or restricted parties."
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n                      You also will not use the Website or Services for any purpose prohibited by U.S. law, including the development,\n                      design, manufacture or production of missiles, nuclear, chemical or biological weapons.\n                    "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [
                                        _vm._v(
                                          "11.15 Modifications to these Terms"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      We reserve the right to modify these Terms including any referenced policies and other documents, effective upon the\n                      commencement of any renewal term. If you object to the updated Terms, as your exclusive remedy, you may choose not\n                      to renew your subscription to our services. If you do not agree to the updated Terms after it becomes effective, you\n                      will no longer have a right to use the Website or Services.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [
                                        _vm._v("11.16 Entire Agreement"),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      These Terms are the final, complete and exclusive agreement of the parties with respect to the subject matter hereof\n                      and supersedes and merges all prior discussions between the parties with respect to such subject matter.\n                    "
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-default",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: { click: _vm.handleConfirm },
                    },
                    [_vm._v("Confirm")]
                  ),
                ]),
              ]),
            ]
          )
        : _c(
            "div",
            {
              staticClass: "modal-dialog go-modal-policy",
              staticStyle: { overflow: "hidden" },
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "div",
                    { staticClass: "go-policy-content-wrap" },
                    [
                      _c(
                        "vue-custom-scrollbar",
                        {
                          staticClass:
                            "go-policy-content-inner overflow-y-scroll customScroll csScrollPosition ps",
                          attrs: { settings: _vm.scrollSettings },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                overflow: "hidden",
                                width: "auto",
                                height: "auto",
                                "word-break": "keep-all",
                              },
                            },
                            [
                              _c("div", { staticClass: "go-section" }, [
                                _c("div", { staticClass: "go-shortcut-box" }, [
                                  _c("strong", [_vm._v("목차")]),
                                  _vm._v(" "),
                                  _c(
                                    "ol",
                                    {
                                      staticClass: "go-shortcut-list",
                                      attrs: { start: "1" },
                                    },
                                    [
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "ts-s1-ko"
                                              )
                                            },
                                          },
                                        },
                                        [_c("a", [_vm._v("계정 생성 및 자격")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "ts-s2-ko"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a", [
                                            _vm._v("웹사이트와 서비스 이용"),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "ts-s3-ko"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a", [
                                            _vm._v("소유권; 지적 재산권"),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "ts-s4-ko"
                                              )
                                            },
                                          },
                                        },
                                        [_c("a", [_vm._v("요금 및 결제 조건")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "ts-s5-ko"
                                              )
                                            },
                                          },
                                        },
                                        [_c("a", [_vm._v("기밀성")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "ts-s6-ko"
                                              )
                                            },
                                          },
                                        },
                                        [_c("a", [_vm._v("제3자 콘텐츠")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "ts-s7-ko"
                                              )
                                            },
                                          },
                                        },
                                        [_c("a", [_vm._v("면책")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "ts-s8-ko"
                                              )
                                            },
                                          },
                                        },
                                        [_c("a", [_vm._v("배상")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "ts-s9-ko"
                                              )
                                            },
                                          },
                                        },
                                        [_c("a", [_vm._v("책임 제한")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "ts-s10-ko"
                                              )
                                            },
                                          },
                                        },
                                        [_c("a", [_vm._v("해지")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "ts-s11-ko"
                                              )
                                            },
                                          },
                                        },
                                        [_c("a", [_vm._v("일반")])]
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    '\n                  이 이용 약관(이하 "약관")은 귀하와 Goover, LLC. 및 Goover의 모회사, 자회사, 그리고 계열사(이하 "Goover" 또는 "회사")\n                  간에 체결됩니다. "가입자" 또는 "사용자"는 이 약관에 동의하는 자를 대신하여 개인 또는 회사, 조직 또는 기타 개체를\n                  의미합니다. 이 약관은 회사의 웹사이트인 goover.ai("웹사이트") 및 모든 기타 서비스를 이용하는 경우에 적용되며, 이에는\n                  체험판 서비스, 베타 서비스 또는 무료 서비스 등이 포함됩니다.\n                '
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                  이 약관은 회사의 책임을 제한하고 집단 소송 면책 및 배심원 재판 포기를 포함합니다. 이 약관에 관련된 분쟁은 분쟁 해결\n                  절차를 통해 처리되어야 하며, 이는 구속적인 중재로 이어질 수 있습니다. 자세한 내용은\n                  "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.scrollToSection("ts-s9-ko")
                                        },
                                      },
                                    },
                                    [_vm._v("제9(책임 제한)")]
                                  ),
                                  _vm._v(" 및\n                  "),
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.scrollToSection(
                                            "ts-s11-10-ko"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("제11.10(분쟁 해결)")]
                                  ),
                                  _vm._v("을 참조하십시오.\n                "),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    '\n                  이 약관 외에도 웹사이트와 서비스 이용에 적용되는 추가적인 약관, 조건, 정책("추가 약관")이 있으며, 이는 본 약관에 참조로\n                  통합됩니다. Goover는 언제든지 이 약관 또는 서비스 관련 정책을 변경할 수 있습니다. 회사는 법령이나 규정의 변경으로 인한\n                  경우를 제외하고, 적어도 30일 전에 효력 발생일을 알릴 것입니다. 업데이트된 약관 및 정책은 각 문서 상단의 날짜를 기준으로\n                  효력이 발생하고 구속력을 갖습니다. 변경 사항이 적용된 후에도 웹사이트와 서비스를 계속 사용하는 것은 변경 사항에 동의하는\n                  것으로 간주됩니다. 변경 사항에 동의하지 않는 경우 웹사이트 또는 서비스 사용을 중단해야 합니다. 업데이트된 약관과 추가\n                  약관은 아래 링크에서 확인할 수 있습니다:\n                '
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "go-table-wrap" }, [
                                  _c("table", { staticClass: "go-table" }, [
                                    _c("tbody", [
                                      _c("tr", [
                                        _c("th", [
                                          _vm._v(
                                            "이용 약관 최종 업데이트 날짜"
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [_vm._v("2022년 5월 1일")]),
                                      ]),
                                      _vm._v(" "),
                                      _c("tr", [
                                        _c("th", [_vm._v("개인정보보호 정책")]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            "Goover 웹사이트 및 서비스에서 데이터를 수집, 사용 및 공유하는 방법을 설명하는 문서"
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("tr", [
                                        _c("th", [
                                          _vm._v("개인 정보 수집 및 이용 약관"),
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            "Goover가 가입자의 개인 정보를 수집할 수 있도록 허용하는 문서"
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                  이 약관을 주의 깊게 읽어주시고 약관에 동의하면, 이 약관은 가입자와 Goover 사이에 구속력 있는 법적 계약이 됩니다.\n                  “동의함” 체크박스를 선택함으로써 귀하는 다음과 같이 표명합니다.\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "ol",
                                  { staticClass: "list-style-lowerAlpha" },
                                  [
                                    _c("li", [
                                      _vm._v(
                                        "이 약관을 읽고 이해하며 이에 동의합니다."
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "가입자는 Goover와 구속력 있는 계약을 체결할 자격이 있는 연령에 도달했습니다."
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "\n                    이 약관에 개인적으로 동의하거나, 웹사이트 또는 서비스를 이용하는 회사, 조직 또는 기타 법인을 대신하여 이 약관에 동의할\n                    권한이 있습니다.\n                  "
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                  이 약관에 동의하지 않는 경우, 이 약관을 수락하지 말고 계정을 생성하지 말아야 하며 웹사이트 또는 서비스를 이용하지\n                  마십시오.\n                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "ts-s1-ko" },
                                },
                                [
                                  _c("h2", [_vm._v("1. 계정 생성 및 자격")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  웹사이트 또는 서비스를 이용하려면 계정을 생성해야 합니다. 계정을 생성하기 전에 웹사이트 또는 서비스 이용이 가입자에게\n                  적용되는 모든 법률 및 규정과 일치하는지 확인하는 것은 가입자의 책임입니다. 계정을 생성할 때 이름과 이메일 주소 또는\n                  전화번호를 입력해야 합니다. 가입자가 제공하는 정보는 개인정보보호 정책에 따라 처리됩니다. 가입자는 본인에 관한 진실되고\n                  정확하며 최신이고 완전한 정보를 제공해야 합니다. 이 약관을 위반하면, 새 계정을 생성하는 것이 금지되며, 회사는 단독\n                  재량으로 가입자의 계정을 비활성화하거나 종료하고 웹사이트와 서비스에 대한 접근을 차단할 수 있습니다.\n                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "ts-s2-ko" },
                                },
                                [
                                  _c("h2", [
                                    _vm._v("2. 웹사이트와 서비스 이용"),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  저희는 웹사이트와 서비스의 모든 권리, 소유권 및 이익을 보유하고 있습니다. 웹사이트와 서비스는 미국 및 전 세계의 저작권법\n                  및 기타 지적 재산권법에 의해 보호됩니다. 이 약관에 따라 가입자는 웹사이트와 서비스를 가입자의 비영리 목적으로만 이용하기\n                  위한 제한적이고 비독점적이며 양도할 수 없는, 그리고 하위 라이선스를 부여할 수 없는 라이선스를 부여받습니다. 웹사이트\n                  또는 서비스의 향후 릴리스, 업데이트 또는 기타 수정은 이 약관에 따라야합니다. 이 약관에 명시되지 않은 모든 권리는 회사가\n                  보유합니다.\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("ol", [
                                    _c("li", [
                                      _c("h3", [_vm._v("2.1 회사의 책임")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "이 약관에 따라 회사는 다음과 같은 내용을 수행할 것입니다."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "ol",
                                        {
                                          staticClass: "list-style-lowerAlpha",
                                        },
                                        [
                                          _c("li", [
                                            _vm._v(
                                              "이 약관 및 추가 약관에 따라 서비스를 제공합니다."
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "가입자에게 서비스를 제공하는 데 적용되는 법률에 따라 서비스를 제공합니다."
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "\n                        업계 표준 조치를 사용하여 해로운 의도를 가진 코드, 파일, 스크립트, 에이전트 또는 프로그램(바이러스, 웜, 타임 밤,\n                        트로이 목마 등 포함)을 스캔, 탐지, 삭제하기 위해 합리적인 노력을 기울입니다.\n                      "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "웹사이트와 서비스에 대한 적절한 지원을 제공하기 위해 합리적인 노력을 기울입니다."
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("2.2 서비스 제한")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      웹사이트와 서비스는 이 약관, 추가 약관 및 적용되는 법률 및 규정에 따라 사용해야 합니다. 이 약관에서 가입자에게\n                      부여되는 권리는 다음과 같은 제한 사항이 적용됩니다: 가입자는 다음을 수행해서는 안 됩니다.\n                    "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "ol",
                                        {
                                          staticClass: "list-style-lowerAlpha",
                                        },
                                        [
                                          _c("li", [
                                            _vm._v(
                                              "\n                        웹사이트 또는 서비스 또는 웹사이트 또는 서비스의 일부분을 판매, 임대, 대여, 양도, 사용허락 또는 기타 상업적으로\n                        이용하는 행위.\n                      "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "\n                        웹사이트 또는 서비스의 상표, 로고를 포함하여 이미지, 텍스트, 스크립트, 페이지 레이아웃 또는 양식을 프레임 또는\n                        포함시키기.\n                      "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              '회사 이름이나 상표를 사용하는 메타태그 또는 기타 "숨겨진 텍스트"를 사용하는 것.'
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "웹사이트 또는 서비스의 일부를 수정, 번역, 적응, 통합, 분해, 파생 작품을 만들거나 역설계하는 행위."
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "\n                        웹사이트 또는 서비스에서 데이터를 스크랩하거나 다운로드하기 위해 자동화된 또는 수동 소프트웨어, 장치 또는 기타\n                        프로세스를 사용.\n                      "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "웹사이트 또는 서비스를 유사한 또는 경쟁하는 웹사이트, 애플리케이션 또는 서비스를 구축하는 행위."
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "웹사이트 또는 서비스 내의 저작권 고지 또는 기타 지적 재산 표시를 제거하거나 파괴하는 행위."
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("2.3 무단 사용")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "어떠한 경우에도 다음과 같은 행위를 하지 않아야 합니다."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "ol",
                                        {
                                          staticClass: "list-style-lowerAlpha",
                                        },
                                        [
                                          _c("li", [
                                            _vm._v(
                                              "웹사이트 또는 서비스의 정상 작동을 방해합니다."
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "웹사이트 또는 서비스에 포함된 보안 또는 사용 규칙을 조작하거나 우회합니다."
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "\n                        전자적 또는 기타 수단을 사용하여 웹사이트 또는 서비스에서 다른 사용자의 연락처 정보를 수확하거나 수집합니다.\n                      "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "\n                        웹사이트 또는 서비스를 제공하거나 지원하기 위해 사용되는 컴퓨터, 서버 또는 기타 인프라를 방해, 과부하게 만들거나\n                        그러한 방해 또는 과부하를 돕습니다.\n                      "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "웹사이트 또는 서비스에 대한 무단 액세스를 시도합니다."
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "\n                        웹사이트, 서비스, 회사 컴퓨터 시스템 또는 저희 공급자의 기술 전달 시스템의 비공개 영역에 접근, 조작 또는\n                        사용합니다.\n                      "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "\n                        회사 시스템 또는 네트워크의 취약점을 탐색, 스캔 또는 테스트하려고 시도하거나 보안 또는 인증 조치를 위반합니다.\n                      "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "\n                        웹사이트, 서비스, 시스템, 자원, 계정, 암호, 서버 또는 웹사이트 또는 서비스를 통해 접근 가능한 네트워크의 보안을\n                        방해하거나 그렇게 해서 웹사이트, 서비스에 피해를 입히지 않습니다. 웹사이트 또는 서비스의 무단 사용은 이 약관에\n                        따라 가입자에게 부여된 라이선스를 종료시키는 행위\n                      "
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "ts-s3-ko" },
                                },
                                [
                                  _c("h2", [_vm._v("3. 소유권; 지적재산권")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  웹사이트와 서비스의 모든 권리, 소유권 및 이익은 Goover에게 독점적으로 있습니다. 웹사이트 또는 서비스의 모든 요소, 비주얼\n                  인터페이스, 그래픽, 디자인, 이미지, 컴파일, 정보, 데이터, 컴퓨터 코드, 소프트웨어 등은 지적 재산 및 기타 법률에 의해\n                  보호됩니다. 사용자는 웹사이트 및 서비스에 포함된 저작권, 상표, 서비스 마크 또는 기타 소유권 고지를 제거, 변경 또는 숨길\n                  수 없습니다. 웹사이트 또는 서비스에 포함된 모든 자료는 Goover 또는 제3자의 소유입니다. 본 약관에 명시적으로 부여되지\n                  않은 모든 권리를 보유합니다.\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("ol", [
                                    _c("li", [
                                      _c("h3", [_vm._v("3.1 피드백")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          '\n                      건의/피드백 페이지 또는 기타 유사한 페이지를 통해 제출된 모든 아이디어, 제안, 제안("피드백")에 대해, Goover에게\n                      완전히 지급된, 로열티가 면제된, 영구적이고, 독점적이지 않으며, 전적으로 하도급 가능한 권리를 부여하며, 이를 사용,\n                      복제, 기타 상업적 또는 비상업적으로 이용할 수 있습니다.\n                    '
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "ts-s4-ko" },
                                },
                                [
                                  _c("h2", [_vm._v("4. 요금 및 결제 조건")]),
                                  _vm._v(" "),
                                  _c("ol", [
                                    _c("li", [
                                      _c("h3", [_vm._v("4.1 요금")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      유료 서비스를 구매할 때, 요금 및 청구 조건에 따라 계정에 대한 모든 요금 및/또는 비용을 지불하는데 동의합니다. 유효한\n                      신용카드 정보를 제공해야 하며, 신용카드 번호 및 결제 처리에 필요한 기타 정보를 제공함으로써, Goover는 즉시 모든 요금\n                      및/또는 비용을 청구할 수 있으며, 추가적인 통지 또는 동의가 필요하지 않습니다. 결제 제공 업체와의 계약이 지정된\n                      신용카드 사용을 규제하며, 해당 계약을 참조하여 가입자의 권리와 책임을 결정해야 합니다. 주기적인 라이선스 요금은\n                      주문서에 명시된 빈도로 사전 청구되며, 사용 기반 및 일회성 요금은 매월 지연 청구됩니다.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("4.2 세금")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          '\n                      모든 요금은 법률, 정부 또는 규제 당국이 부과하는 세금, 부과금, 관세 또는 기타 유사한 과세를 포함하지 않습니다. 이는\n                      판매, 사용, 부가가치, 소비, 통신 또는 원천징수세 등의 세금을 포함합니다("세금"). 본 약관에 따른 세금은 Goover의\n                      순이익, 재산 또는 직원에 기반한 세금을 제외하고, 사용자가 부담합니다. 법률에 따라 Goover에 지급할 금액에서 세금을\n                      공제해야 하는 경우, Goover가 제공하는 적절한 세금 증명서 또는 문서를 받은 후에 공제되거나 제거됩니다. 공제된 세금을\n                      적절한 당국에 지불한 증거를 Goover에 제공해야 합니다. 세금은 청구서의 별도 항목으로 표시됩니다.\n                    '
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("4.3 가격 변경")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      서비스 요금을 변경하거나 추가 요금이나 비용을 부과하는 경우, 사용자에게 사전 통지를 제공합니다. 변경 사항을 수락하지\n                      않는 경우, Goover는 서비스 제공을 중단할 권리를 보유합니다.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [
                                        _vm._v("4.4 결제 지연, 미납, 정지"),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      Goover는 언제든지 자체 재량으로 사용자의 계정을 비활성화, 종료, 접근을 차단하거나, 웹사이트 및 서비스에 대한 접근을\n                      차단할 권리를 보유하며, 이는 미납, 지연된 결제 또는 청구시 결제 수단을 청구하지 못한 경우에도 적용됩니다.\n                    "
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "ts-s5-ko" },
                                },
                                [
                                  _c("h2", [_vm._v("5. 기밀성")]),
                                  _vm._v(" "),
                                  _c("ol", [
                                    _c("li", [
                                      _c("h3", [_vm._v("5.1")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          '\n                      기밀 정보의 정의 본 약관에 따라 처리해야 하는 기밀로 지정되거나 정보의 성격이나 공개 상황을 고려할 때 합리적으로\n                      기밀로 간주되어야 하는 비공개 정보("기밀 정보")입니다.\n                    '
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "기밀 정보에는 다음이 포함되지만 이에 국한되지 않습니다."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "ol",
                                        {
                                          staticClass: "list-style-lowerAlpha",
                                        },
                                        [
                                          _c("li", [
                                            _vm._v(
                                              "기술, 고객, 사업 계획, 마케팅 및 영업 활동, 재무, 운영 및 기타 사업 정보에 대한 비공개 정보."
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "계정 또는 웹사이트 또는 서비스 사용에 관한 당사와의 논의 또는 협상의 존재 및 내용."
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "본 약관을 위반하지 않고 공개 가능한 정보:"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "ol",
                                        {
                                          staticClass: "list-style-lowerAlpha",
                                        },
                                        [
                                          _c("li", [
                                            _vm._v(
                                              "당사로부터 수령 시점에 이미 알고 있었다는 것을 문서로 증명할 수 있는 경우;"
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "\n                        불법적이거나 불공정한 행위로 정보를 획득하거나 공개하지 않은 제3자로부터 받은 정보 또는 당사 또는 제3자의 권리를\n                        침해하지 않은 경우.\n                      "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              "기밀 정보를 참조하지 않고 독립적으로 개발되었다는 것을 문서로 증명할 수 있는 정보."
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("5.2 기밀성")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      사용자는 본 약관의 범위를 벗어나는 목적으로 기밀 정보를 공개하거나 사용하지 않도록 동의합니다. 당사는 본 약관에\n                      명시된 범위와 동일한 범위의 기밀성 의무를 지닌 당사 직원, 감사인, 회계사, 변호사 또는 자문인에게 기밀 정보를 공개할\n                      수 있습니다.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("5.3 보호")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      사용자는 적어도 동일한 수준의 주의를 기울여 기밀 정보의 무단 사용을 방지해야 합니다. 이는 사용자 자신의 기밀 및 소유\n                      정보에 대한 것과 같은 종류의 정보를 다루는 데 사용하는 주의를 적용해야 하며, 이러한 주의는 합리적인 기준을 충족해야\n                      합니다. 본 약관에 포함된 기밀성 의무는 본 약관의 적용 대상이 되는 사항에 대한 이전의 어떤 비밀 유지 조항도 대체하고\n                      대신합니다.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("5.4 강제 공개")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          '\n                      규정, 법률, 소환장 또는 법원 명령에 따라 기밀 정보를 공개해야 하는 경우("강제 공개")에도 당사는 해당 조치를 취할 수\n                      있습니다. 법률상 허용되는 한도 내에서 강제 공개에 대한 통지를 받을 경우 사용자에게 통보해야 합니다. 사용자는 강제\n                      공개와 관련하여 당사에 합리적인 협조를 제공해야 합니다.\n                    '
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "ts-s6-ko" },
                                },
                                [
                                  _c("h2", [_vm._v("6. 제3자 콘텐츠")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      '\n                  웹사이트 또는 서비스에는 당사가 소유하거나 통제하지 않는 제3자 웹사이트, 광고주, 서비스, 특별 제공, 기타 이벤트 또는\n                  활동에 대한 링크가 포함될 수 있습니다("제3자 콘텐츠"). 당사는 어떠한 제3자 콘텐츠에 대해서도 보증하지 않으며 책임을 지지\n                  않습니다. 웹사이트 또는 서비스를 이용하거나 접속함에 있어 제3자 콘텐츠에 접근하는 경우, 사용자는 스스로의 위험으로\n                  이러한 제3자 콘텐츠를 사용하거나 접근하며, 제3자 콘텐츠 사용 또는 접근과 관련하여 당사는 어떠한 책임도 지지 않습니다.\n                '
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "ts-s7-ko" },
                                },
                                [
                                  _c("h2", [_vm._v("7. 면책")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  본 약관을 사용자는 명백하게 이해하고 동의합니다. 적용되는 법률의 범위 내에서, 웹사이트와 서비스의 이용은 전적으로\n                  사용자의 책임이며, 웹사이트와 서비스는 “있는 그대로” 및 “사용 가능한” 상태로 제공됩니다. 당사는 명시적이거나 묵시적인\n                  모든 보증, 대표 및 조건을 명시적으로 부인합니다. 이에는 상품성, 특정 목적에의 적합성 및 비침해에 대한 묵시적 보증 또는\n                  조건이 포함됩니다.\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "당사는 다음 사항에 대해 어떠한 보증, 대표 또는 조건도 제공하지 않습니다."
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "ol",
                                    { staticClass: "list-style-decimal" },
                                    [
                                      _c("li", [
                                        _vm._v(
                                          "웹사이트나 서비스가 사용자의 요구사항을 충족할 것이라는 보증;"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "웹사이트나 서비스 이용이 끊김 없이, 적시에, 안전하게 또는 오류 없이 이루어질 것이라는 보증;"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "웹사이트나 서비스 사용 결과가 정확하거나 신용할 수 있을 것이라는 보증;"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "웹사이트 또는 서비스의 오류가 수정될 것이라는 보증."
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  서비스는 지연, 취소 및 기타 중단에 영향을 받을 수 있습니다. 당사 또는 웹사이트 또는 서비스를 통해 얻은 구두 또는 서면의\n                  어떠한 조언이나 정보도 본 약관에서 명시적으로 규정된 것 이외에 어떠한 보증을 생성하지 않습니다.\n                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "ts-s8-ko" },
                                },
                                [
                                  _c("h2", [_vm._v("8. 책임 제한")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  본 약관과 관련하여 발생하는 모든 청구와 관련하여 당사, 당사의 법인 부모 회사, 자회사 및 계열사, 각 사의 임원, 이사,\n                  직원, 대리인, 대표, 파트너 및 라이선스를 면책하고, 방어하며 배상에 동의합니다. 이에는 합리적인 변호사 비용을 포함한\n                  손해, 손실, 비용, 책임 및 비용이 포함되지만 이에 국한되지 않습니다.\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "ol",
                                    { staticClass: "list-style-lowerAlpha" },
                                    [
                                      _c("li", [
                                        _vm._v(
                                          "웹사이트 또는 서비스의 사용 또는 사용 불능;"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "웹사이트 또는 서비스의 오용 또는 본 약관 중 하나에 대한 위반;"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "다른 당사자의 권리에 대한 위반; 또는"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "적용되는 법률, 규정 또는 규정에 대한 위반."
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  회사는 회사의 비용으로 사용자가 배상해야 하는 사안의 독점적 방어와 통제를 담당할 권리를 보유하며, 그런 경우에 사용자는\n                  가능한 모든 방어에 대해 회사와 완전히 협력할 것입니다. 웹사이트 또는 서비스에 대한 계정, 본 약관 또는 액세스의 종료\n                  후에도 본 섹션의 규정은 적용됩니다.\n                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "ts-s9-ko" },
                                },
                                [
                                  _c("h2", [_vm._v("9. 책임 제한")]),
                                  _vm._v(" "),
                                  _c("ol", [
                                    _c("li", [
                                      _c("h3", [_vm._v("9.1")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      특정 손해에 대한 면책 적용되는 법률이 허용하는 최대한으로, 당사는 웹사이트 또는 서비스, 이를 포함하여 사용 또는 사용\n                      불능; 당사가 제공하는 콘텐츠; 제3자 지적 재산 권리 청구와 관련하여 취한 조치; 데이터 손실; 생산; 또는 영업 중단 또는\n                      대체 상품 또는 서비스 구매와 관련된 비용이나 손해로 인한 이익이나 수익의 손실, 정신적 고통, 결과적 손해, 징계적\n                      손해, 특별 손해 또는 간접 손해에 대해 책임을 지지 않습니다.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("9.2 책임 제한")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      어떠한 경우에도 사용자가 웹사이트와 서비스를 사용함으로써 회사에게 지급된 금액을 초과하여 회사는 사용자에게 책임을\n                      지지 않습니다. 첫 번째 청구를 제기하는 구독 기간 동안 당사에게 어떠한 금액도 지불하지 않은 경우, 회사의 단독 및\n                      배타적 책임은 50달러(50$)로 제한됩니다.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("9.3 예외")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      일부 관할 지역에서는 특정 손해의 배제 또는 제한을 허용하지 않습니다. 이러한 법률이 가입자에게 적용되는 경우, 일부\n                      또는 모든 면책, 배제 및 제한이 가입자에게 적용되지 않을 수 있으며 가입자는 추가 권리를 가질 수 있습니다.\n                    "
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "ts-s10-ko" },
                                },
                                [
                                  _c("h2", [_vm._v("10. 종료")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  회사는 단독 재량으로 웹사이트 또는 서비스를 수정하거나 중단하거나 가입자의 웹사이트 또는 서비스에 대한 액세스를 수정,\n                  중단 또는 종료할 수 있습니다. 이는 가입자나 제삼자에게 책임을 지지 않고 어떠한 이유로든 통지 없이 이루어질 수 있습니다.\n                  웹사이트 또는 서비스에 대한 액세스를 정지하거나 종료함으로써, 회사는 법적 조치를 취할 권리를 보유하며, 이에는 민사, 형사\n                  또는 구속 명령을 포함하지만 이에 국한되지 않습니다. 웹사이트 또는 서비스 이용 권한이 종료된 후에도 본 약관은 가입자에게\n                  집행 가능하며, 가입자가 회사에게 지불해야 하는 미납 금액은 여전히 납부됩니다. 본 약관의 종료에도 불구하고 성질상 종료\n                  이후에도 계속해서 적용되어야 하는 모든 조항은 완전한 효력을 유지합니다.\n                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "ts-s11-ko" },
                                },
                                [
                                  _c("h2", [_vm._v("11. 일반")]),
                                  _vm._v(" "),
                                  _c("ol", [
                                    _c("li", [
                                      _c("h3", [_vm._v("11.1 양도")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      본 약관과 가입자의 권리 및 의무는 회사의 사전 서면 동의 없이 양도, 하청, 위임 또는 다른 방법으로 이전할 수 없으며,\n                      이를 위반하는 경우 양도, 하청, 위임 또는 이전은 무효입니다.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("11.2 전자 통신")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      회사는 웹사이트 또는 서비스에 공지를 게시하거나 가입자에게 이메일로 연락하거나 가입자가 웹사이트 또는 서비스를\n                      방문할 때 전자 수단으로 가입자와 소통합니다. 계약적 목적으로 가입자는 다음에 동의합니다.\n                    "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "ol",
                                        {
                                          staticClass: "list-style-lowerAlpha",
                                        },
                                        [
                                          _c("li", [
                                            _vm._v(
                                              "전자 형식으로부터 회사와의 의사소통을 받아들이며;"
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              '\n                        모든 약관, 합의, 공지, 공개, 그리고 기타 의사소통 및 문서를 전자적으로 제공하며 이러한 의사소통 또는 문서가 종이\n                        기반의 "서면"으로 표시된 경우와 동일한 법적 효력을 가진다고 인정합니다.\n                      '
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("11.3 통지")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      가입자는 회사가 이메일, 일반 우편 또는 웹사이트 또는 서비스에 게시함으로써 가입자에게 통지를 제공할 수 있다는 것에\n                      동의합니다. 가입자는 "
                                        ),
                                        _c("a", [_vm._v("contact@goover.ai")]),
                                        _vm._v(
                                          "로 연락하여 회사에게 통지를 제공할 수 있습니다.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("11.4 제삼자 데이터")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      회사는 단독 재량으로 웹사이트 또는 서비스를 수정하거나 중단하거나 가입자의 웹사이트 또는 서비스에 대한 액세스를\n                      수정, 중단 또는 종료할 수 있습니다. 이는 가입자나 제삼자에게 책임을 지지 않고 어떠한 이유로든 통지 없이 이루어질 수\n                      있습니다. 웹사이트 또는 서비스에 대한 액세스를 정지하거나 종료함으로써, 회사는 법적 조치를 취할 권리를 보유하며,\n                      이에는 민사, 형사 또는 구속 명령을 포함하지만 이에 국한되지 않습니다. 웹사이트 또는 서비스 이용 권한이 종료된 후에도\n                      본 약관은 가입자에게 집행 가능하며, 가입자가 회사에게 지불해야 하는 미납 금액은 여전히 납부됩니다. 본 약관의\n                      종료에도 불구하고 성질상 종료 이후에도 계속해서 적용되어야 하는 모든 조항은 완전한 효력을 유지합니다.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("11.5 당사자 관계")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      당사자는 독립 계약자입니다. 본 약관은 당사자 간의 파트너십, 프랜차이즈, 합작투자, 대리, 신탁 또는 고용 관계를\n                      창립하지 않습니다.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("11.6 가지치기")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      본 약관의 일부가 무효 또는 집행 불능으로 판명되는 경우, 해당 부분은 가능한 한 원래 당사자의 의도를 반영하도록\n                      해석되며 나머지 부분은 완전한 효력을 유지합니다.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("11.7 불가항력")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      회사는 합리적인 통제를 벗어난 원인으로 인한 지연이나 이행 불능에 대해 책임을 지지 않습니다. 이는 하나가 아닌 모든\n                      종류의 천재지변, 전쟁, 전염병, 팬데믹, 테러, 폭동, 민간 또는 군사 당국의 행위, 화재, 홍수, 사고, 파업, 또는 운송\n                      수단, 연료, 에너지, 노동 또는 자재의 부족을 포함할 수 있습니다.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("11.8 준거법 및 관할")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      이 약관과 이 약관으로 발생한 모든 분쟁은 캘리포니아주 법에 따라 해석되고 적용됩니다. 이에는 국제 상품 판매에 관한\n                      유엔 협약이나 컴퓨터 정보 거래법을 포함하지 않습니다.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [
                                        _vm._v("11.9 관할 및 배심원 재판 포기"),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      본 약관은 영어를 정본으로 합니다. 본 약관 및 서비스는 산타클라라 카운티, 캘리포니아에 위치한 주 및 연방 법원이\n                      발생한 모든 분쟁을 심리할 독점적 관할권을 갖습니다. 각 당사자는 본관할의 해당 법원에 대해 독점적 관할권에 동의하며\n                      법정, 관할권, 편의에 대한 이의제기 및 유사한 이론에 대해 이의를 제기하지 않을 것입니다. 각 당사자는 또한 본 약관에\n                      따른 모든 소송에서 배심원 재판권을 포기합니다.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      { attrs: { id: "ts-s11-10-ko" } },
                                      [
                                        _c("h3", [_vm._v("11.10 분쟁 해결")]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n                      당사자간 분쟁을 신속하고 경제적으로 해결하기 위해, 모든 당사자는 본 약관과 관련된 모든 분쟁은 구속적 중재를 통해\n                      해결된다는 것에 동의합니다. 중재는 법원에서 소송보다 덜 공식적입니다. 중재는 판사나 배심원 대신 중립적인 중재인을\n                      사용하며, 법원보다 제한된 발견을 허용할 수 있고, 법원에 의한 아주 제한된 검토를 받을 수 있습니다. 중재인은 법원이\n                      수여할 수 있는 동일한 손해배상 및 구제를 수여할 수 있습니다. 중재 협약에는 계약, 무과계, 법률, 사기, 허위진술 또는\n                      기타 법률 이론에 기초한 이 약관의 어떠한 측면과 관련된 모든 청구가 포함되며, 이러한 청구가 이 약관의 종료 후에\n                      발생하더라도 마찬가지입니다. 이 약관에 동의함으로써, 양 당사자는 배심원 재판권 및 집단 소송에 참여할 권리를\n                      포기한다는 것을 이해하고 동의합니다.\n                    "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("11.11 포기")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      한 가지 경우에 이 약관의 규정에 대한 포기나 집행유예가 다른 규정이나 그러한 규정에 대한 다른 경우에 대한 포기로\n                      간주되지 않습니다.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [
                                        _vm._v(
                                          "11.12 캘리포니아 주민에게 공지"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      캘리포니아 민법 제 1789.3 조에 따라, 캘리포니아 주민은 다음과 같은 구체적인 소비자 권리 정보를 받을 수 있습니다.\n                    "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [_vm._v("웹사이트 제공자:")]),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        { staticClass: "list-style-disc" },
                                        [
                                          _c("li", [_vm._v("Goover LLC.")]),
                                          _vm._v(" "),
                                          _c("li", [_vm._v("440 N Wolfe Rd.")]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v("Sunnyvale, CA 94085"),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v("이메일 : "),
                                            _c("a", [
                                              _vm._v("contact@goover.ai"),
                                            ]),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      웹사이트 이용에 대한 불만을 제기하거나 웹사이트 이용에 관한 추가 정보를 받으려면 위 주소로 편지를 보내거나 전자\n                      메일이나 전화로 문의하십시오.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("11.13 국제 접근")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      웹사이트 및 서비스는 미국 이외의 국가에서 접근할 수 있습니다. 회사는 웹사이트 및 서비스가 다른 지역에서 사용하거나\n                      접근하기에 적합하다는 보증이나 진술을 하지 않습니다. 미국 외부에서 웹사이트나 서비스를 접근하고 사용하는 경우 미국\n                      및 해당 지역의 관련 법규를 준수해야 합니다.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      [
                                        _c("h3", [_vm._v("11.14 수출 통제")]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n                      웹사이트, 서비스 및 회사가 제공하는 기타 기술 및 그 파생물은 미국 및 기타 관할 지역의 수출 법규에 적용될 수\n                      있습니다. 특히, 웹사이트와 서비스는 다음과 같이 수출 또는 재수출해서는 안 됩니다.\n                    "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "ol",
                                          {
                                            staticClass:
                                              "list-style-lowerAlpha",
                                          },
                                          [
                                            _c("li", [
                                              _vm._v(
                                                "미국 정부가 금지한 국가로 수출한 경우"
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("li", [
                                              _vm._v(
                                                "\n                        미국 재무부의 특별지정국민 명단이나 미국 상무부의 거부인 명단 또는 기관 명단에 기재된 사람에게 수출하거나\n                        재수출하지 않습니다.\n                      "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("P", [
                                          _vm._v(
                                            "웹사이트나 서비스를 사용함으로써 가입자는 다음과 같이 표시하고 보증합니다."
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "ol",
                                          {
                                            staticClass:
                                              "list-style-lowerAlpha",
                                          },
                                          [
                                            _c("li", [
                                              _vm._v(
                                                '미국 정부가 금지하는 국가에 위치하지 않거나 미국 정부가 "테러 지원" 국가로 지정한 국가에 위치하지 않으며'
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("li", [
                                              _vm._v(
                                                "미국 정부의 금지 또는 제한 당사자 목록에 나열되지 않았습니다."
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [
                                        _vm._v("11.15 이 약관에 대한 변경"),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      회사는 이 약관을 변경할 권리를 보유하며, 기타 문서와 정책에 대한 참조를 포함하여 변경된 약관은 갱신 기간의 시작과\n                      함께 효력을 발휘합니다. 변경된 약관에 동의하지 않는 경우, 독점 구제 방법으로, 서비스 구독을 갱신하지 않을 수\n                      있습니다. 변경된 약관이 적용된 후에 동의하지 않는 경우, 웹사이트나 서비스를 이용할 권리가 없게 됩니다.\n                    "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c("h3", [_vm._v("11.16 전체 합의")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                      이 약관은 당사자들이 이와 관련된 기존의 모든 논의를 대체하고 통합하는 최종, 완전하고 독점적인 합의이며, 이와 관련된\n                      당사자들 간의 모든 논의를 대체하고 통합합니다.\n                    "
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-default",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: { click: _vm.handleConfirm },
                    },
                    [_vm._v("확인")]
                  ),
                ]),
              ]),
            ]
          ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("div", { staticClass: "modal-title" }, [_vm._v("이용 약관")]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn go-btn-icon close",
          attrs: { type: "button", "data-dismiss": "modal" },
        },
        [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }